// extracted by mini-css-extract-plugin
export default {"parralaxBlock":"ParallaxBlock_parralaxBlock__iL1v1"};